import { ReactElement, ReactNode } from 'react';
import { Container, Flex, Box, Grid } from '@chakra-ui/react';

import Heading from 'components/atoms/heading/index';
import RegistrationStep, {
  RegistrationStepProps,
} from 'components/molecules/candidates/registrationStep';

export interface RegistrationStepsProps {
  registrationStepsTitle: string | ReactNode;
  registrationSteps: Array<RegistrationStepProps>;
}

const RegistrationSteps = ({
  registrationStepsTitle,
  registrationSteps,
}: RegistrationStepsProps): ReactElement => (
  <Box bg='background.700' w='100%' py='20' px={[4, 4, 0, 0]}>
    <Container maxW='container.xxl'>
      <Flex flexDir={['column', 'column', 'row', 'row']}>
        <Heading format='h2' mb={[16, 16, 0, 0]} mr={8}>
          {registrationStepsTitle}
        </Heading>

        <Grid
          templateColumns={[
            'repeat(1, 1fr)',
            'repeat(1, 1fr)',
            'repeat(3, 1fr)',
            'repeat(3, 1fr)',
          ]}
          gap={[16, 16, 4, 4]}
        >
          {registrationSteps.map((step) => (
            <RegistrationStep key={step.step} {...step} />
          ))}
        </Grid>
      </Flex>
    </Container>
  </Box>
);

export default RegistrationSteps;
